/**
 * metaLeadGen/formatters.ts
 *
 * Formatting helpers — completely separate from calculations.
 * All formatters accept a raw number and return a display string.
 *
 * currencyCode defaults to "USD". Pass it through from MetaLeadGenSummary
 * when building UI to keep formatting consistent.
 */

export function formatCurrency(n: number, currencyCode = "USD"): string {
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCpm(n: number, currencyCode = "USD"): string {
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPercent(n: number, decimals = 1): string {
  return `${n.toFixed(decimals)}%`;
}

export function formatNumber(n: number): string {
  return n.toLocaleString("en-US");
}

export function formatDecimal(n: number, decimals = 2): string {
  return n.toFixed(decimals);
}

export function formatPercentChange(n: number): string {
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(1)}%`;
}
